export default __webpack_public_path__ + "static/media/app-street.6d84c180.png";